(function () {
  if (window.__twb) return; window.__twb = true;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('twb-js');
  function reveal(scope) {
    var els = [].slice.call((scope || document).querySelectorAll('.twb-reveal:not(.is-in)'));
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { threshold: 0.1 });
    els.forEach(function (e) { io.observe(e); });
  }
  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    reveal();
    if (!document.querySelector('.twb-top')) {
      var b = document.createElement('button'); b.className = 'twb-top'; b.type = 'button'; b.setAttribute('aria-label', 'Back to top');
      b.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
      b.onclick = function () { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); };
      document.body.appendChild(b);
      var f = function () { b.classList.toggle('is-on', window.scrollY > 700); };
      window.addEventListener('scroll', f, { passive: true }); f();
    }
  });
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();
